function generateUUID() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    const r = Math.random() * 16 | 0
    const v = c === 'x' ? r : (r & 0x3 | 0x8)
    return v.toString(16)
  })
}

export function getDeviceId() {
  const key = 'screen_device_id'
  let deviceId = localStorage.getItem(key)
  if (!deviceId) {
    deviceId = generateUUID()
    localStorage.setItem(key, deviceId)
  }
  return deviceId
}

export function getUrlParam(name) {
  const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`)
  const r = window.location.search.substr(1).match(reg)
  if (r != null) return decodeURIComponent(r[2])
  return null
}

export function getCompanyId() {
  return getUrlParam('company_id')
}

export function getCostCenterId() {
  return getUrlParam('cost_center_id')
}

export function getScreenId() {
  return getUrlParam('screen_id')
}

export function validateParams() {
  const companyId = getCompanyId()
  const costCenterId = getCostCenterId()
  // const screenId = getScreenId()
  return {
    isValid: companyId && costCenterId, // && screenId,
    companyId,
    costCenterId,
    // screenId,
    screenId: getScreenId()
  }
}
